import script from "./BannedList.vue?vue&type=script&setup=true&lang=js"
export * from "./BannedList.vue?vue&type=script&setup=true&lang=js"

import "./BannedList.vue?vue&type=style&index=0&id=75b15ea8&scoped=true&lang=scss"
script.__scopeId = "data-v-75b15ea8"

export default script